<template>
  <div class="col border border-3">
    Arrive en cours de séance à
    {{ $moment(toLocalTime(event.date)).locale("fr").format("HH[h]mm") }},
    {{ getPersonName({ personId: event.contact_id, personType: "contact" }) }}, après la résolution
    n°{{ voteOrder }}.
  </div>
</template>

<script>
export default {
  props: ["event", "voteOrder"],
};
</script>
